import KeyboardHelper from '../helpers/KeyboardHelper';
import { Helpers } from '../helpers/helpers';


type OptionItem = {
    value: string | number;
    label: string;
};

export default class CitySelect {
    private readonly $holder: JQuery;

    private $nativeSelect: JQuery;
    private $dropdown: JQuery;
    private $clearButton: JQuery;
    private $selectedLabel: JQuery;
    private $selectedWrapper: JQuery;
    private $closeButton: JQuery;
    private $searchInput: JQuery;
    private $optionsItem: JQuery;

    private selectors = {
        nativeSelect: '.js-city-select-native',
        dropdown: '.js-city-select-dropdown',
        clearButton: '.js-city-select-clear',
        selectedLabel: '.js-city-select-selected-label',
        selectedWrapper: '.js-city-select-selected-wrapper',
        closeButton: '.js-city-select-close-button',
        searchInput: '.js-city-select-search-input',
        optionsItem: '.js-city-select-options-item',
    }

    private Classes = {
        OPENED: 'opened',
        HAS_VALUE: 'has-value',
        HIDE_ITEM: 'hide',
        ACTIVE_ITEM: 'active',
    }

    private isOpened = false;

    constructor($holder: JQuery) {
        this.$holder = $holder;
        this.$nativeSelect = this.$holder.find(this.selectors.nativeSelect);
        this.$dropdown = this.$holder.find(this.selectors.dropdown);
        this.$clearButton = this.$holder.find(this.selectors.clearButton);
        this.$closeButton = this.$holder.find(this.selectors.closeButton);
        this.$selectedLabel = this.$holder.find(this.selectors.selectedLabel);
        this.$searchInput = this.$holder.find(this.selectors.searchInput);
        this.$optionsItem = this.$holder.find(this.selectors.optionsItem);
        this.$selectedWrapper = this.$holder.find(this.selectors.selectedWrapper);

        this.clickSelectedInnerHandler = this.clickSelectedInnerHandler.bind(this);
        this.clickOutsideCalendarHandler = this.clickOutsideCalendarHandler.bind(this);
        this.searchInputHandler = this.searchInputHandler.bind(this);
        this.clickOptionHandler = this.clickOptionHandler.bind(this);

        this.init();
    }

    private init(): void
    {
        this.initEvents();
    }

    private initEvents(): void
    {
        this.$selectedWrapper.on('click', this.clickSelectedInnerHandler);
        this.$searchInput.on('input', this.searchInputHandler);
        this.$dropdown.on('click', this.selectors.optionsItem, this.clickOptionHandler);
        this.$closeButton.on('click', () => {
           this.closeDropdown();
        });

        this.$clearButton.on('click', (evt) => {
            evt.stopPropagation();
            this.clearAll();
        });

        $(document).on('click', this.clickOutsideCalendarHandler);
        $(document).on('keydown', (evt) => {
            if (!KeyboardHelper.isEsc(evt)) {
                return;
            }

            this.closeDropdown();
        });
    }

    public resetValue(): void {
        this.clearAll();
    }

    private searchInputHandler(): void {
        const value = this.$searchInput.val();

        let search = '';

        if (typeof value === 'string') {
            search = value;
        }

        this.filterList(search);
    }

    private clickSelectedInnerHandler(evt: JQuery.ClickEvent): void
    {
        this.toggleDropdownState();
    }

    private clickOutsideCalendarHandler(evt: JQuery.ClickEvent): void
    {
        const $target = $(evt.target);

        if (!this.isOpened
            || $target.closest(this.selectors.dropdown).length
            || $target.closest(this.selectors.selectedWrapper).length) {
            return;
        }

        this.closeDropdown();
    }

    private clickOptionHandler(evt: JQuery.ClickEvent): void {
        const $target = $(evt.currentTarget);
        const isActive = $target.hasClass(this.Classes.ACTIVE_ITEM)
        const optionItem = this.getOptionItem($target);

        if (!optionItem) {
            return;
        }

        const isEmpty = optionItem.value === 'empty';

        if (isActive || isEmpty) {
            this.clearAll();
            return;
        }

        this.$optionsItem.removeClass(this.Classes.ACTIVE_ITEM);

        this.setActiveElement($target, optionItem);
        this.closeDropdown();
    }

    private clearAll(): void {
        this.$optionsItem.removeClass(this.Classes.ACTIVE_ITEM);
        const emptyOption = this.getEmptyValue();

        this.$nativeSelect.val(emptyOption.value);
        this.$holder.removeClass(this.Classes.HAS_VALUE);
        this.setSelectedView(emptyOption);
        this.triggerNativeChange();
        this.closeDropdown();
    }

    private toggleDropdownState(): void {
        if (this.isOpened) {
            this.closeDropdown();
        } else {
            this.openDropdown();
        }
    }

    private openDropdown(): void {
        this.isOpened = true;
        this.$holder.addClass(this.Classes.OPENED);
        Helpers.setOverflowHtml(true);
    }

    private closeDropdown(): void {
        this.isOpened = false;
        this.$holder.removeClass(this.Classes.OPENED);
        this.$searchInput.val('');
        this.filterList('');
        Helpers.setOverflowHtml(false);
    }

    private getEmptyValue(): OptionItem {
        return {
            label: 'По всей России',
            value: '',
        }
    };

    private setSelectedView(
        option: OptionItem,
    ): void {
        this.$selectedLabel.text(option.label);
    }

    private setActiveElement($element: JQuery, option: OptionItem): void {
        $element.addClass(this.Classes.ACTIVE_ITEM);
        this.$holder.addClass(this.Classes.HAS_VALUE);
        this.setSelectedView(option);
        this.$nativeSelect.val(option.value);
        this.triggerNativeChange();
    }

    private getOptionItem($element: JQuery): OptionItem | null  {
        const value = $element.data('city-select-value') as string;
        const label = $element.data('city-select-label') as string;

        if (typeof value === 'undefined' || typeof label === 'undefined') {
            return null
        }

        return {
            value,
            label,
        };
    }

    private filterList(search: string): void {
        this.$optionsItem.each((_, item) => {
            const searchTransformed = search.toLowerCase();

            if (!searchTransformed) {
                $(item).removeClass(this.Classes.HIDE_ITEM);
                return;
            }

            const label = $(item).data('city-select-label') as string;

            if (!label || typeof label !== 'string' || !label.toLowerCase().includes(searchTransformed)) {
                $(item).addClass(this.Classes.HIDE_ITEM);
                return;
            }

            $(item).removeClass(this.Classes.HIDE_ITEM);
        });
    }

    private hasValue(): boolean {
        return Boolean(this.$nativeSelect.val());
    }

    private triggerNativeChange(): void {
        this.$nativeSelect.trigger('change');
    }

}
